<template>
    <div>
        <div class="grid grid-cols-1 md:grid-cols-2 bg-white bg-opacity-80 border divide-y md:divide-y-0 md:divide-x" >
            <div class="p-3">
                
                <ShowImage :image_file_path="single_evidence_detail.file_path" :image_file_name="single_evidence_detail.file_name" :image_uid="single_evidence_detail.uid" :is_include="single_evidence_detail.exclude" v-on:exclude-image-from-evidence="excludeImage" v-on:evidence-image-include="includeImage"></ShowImage>

                <nav v-if="total_evidence != 1" class="mt-3 flex items-center justify-between">
                    <div class="w-0 flex-1 flex">
                        <a href="javascript:void(0)" v-if="active!=0" class="inline-flex items-center text-gray-600 hover:text-gray-800"  @click="move(-1)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                        </a>

                        <span v-else class="inline-flex items-center text-gray-300 cursor-not-allowed">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                        </span>
                    </div>

                    <span class="text-sm sm:text-base font-semibold text-gray-800">{{active+1}} / {{total_evidence}}</span>

                    <div class="w-0 flex-1 flex justify-end">
                        <a href="javascript:void(0)" v-if="active!=total_evidence-1" class="inline-flex items-center text-gray-600 hover:text-gray-800" @click="move(1)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </a>

                        <span v-else class="inline-flex items-center text-gray-300 cursor-not-allowed">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </span>
                    </div>
                </nav>
            </div>
            <div class="px-4 py-3">
                <!-- {{single_evidence_detail}} -->
                <ImageData :evidence_data="single_evidence_detail" :protest_request_uid="protest_request_uid"></ImageData>
            </div>
        </div>
    </div>
</template>

<script>
import ShowImage from '../Admin/Image.vue';
import ImageData from '../Admin/ImageData.vue';

export default {
props :["single_evidence_detail","total_evidence","active","protest_request_uid"],
  components: {
    ShowImage:ShowImage,
    ImageData:ImageData
  },
  data() {
    return {
        evidence_detail:"",
        image_name:"",
    };
  },
  created(){
      this.evidence_detail = this.single_evidence_detail;
  },
  methods: {
   move(direction){
        this.$emit('move-image-to-next',{'direction':direction});
   },
   excludeImage($request){
        this.$emit('exclude-image-in-evidnece',{'image_uid':$request.image_uid,'comment':$request.comment});
   },
   includeImage(request){
       this.$emit("include-image-in-evidnece",{'image_uid':request.image_uid});
   }

  }
};
</script>

<style scoped>
</style>
